import axiosInstance from "../configuration/api";
import { CreateProductData } from "../interface/product";

export const createProduct = async (productData: CreateProductData) => {
  const baseUrl = process.env.REACT_APP_API_HOST;
  const response = await axiosInstance.post(
    `${baseUrl}/api/v1/product`,
    productData
  );
  return response.data;
};

export const getAllProducts = async (seriesId?: string, search?: string) => {
  const baseUrl = process.env.REACT_APP_API_HOST;
  const params: Record<string, string> = {};
  if (seriesId) params.seriesId = seriesId;
  if (search) params.search = search;

  const response = await axiosInstance.get(`${baseUrl}/api/v1/product`, {
    params,
  });
  return response.data;
};

export const updateProduct = async (
  id: string,
  updateData: Partial<CreateProductData>
) => {
  const baseUrl = process.env.REACT_APP_API_HOST;
  const response = await axiosInstance.patch(
    `${baseUrl}/api/v1/product/${id}`,
    updateData
  );
  return response.data;
};

export const deleteProduct = async (id: string) => {
  const baseUrl = process.env.REACT_APP_API_HOST;
  const response = await axiosInstance.delete(
    `${baseUrl}/api/v1/product/${id}`
  );
  return response.data;
};

export const likeProduct = async (id: string) => {
  const baseUrl = process.env.REACT_APP_API_HOST;
  const response = await axiosInstance.post(
    `${baseUrl}/api/v1/product/${id}/upvote`
  );
  return response.data;
};
export const unLikeProduct = async (id: string) => {
  const baseUrl = process.env.REACT_APP_API_HOST;
  const response = await axiosInstance.delete(
    `${baseUrl}/api/v1/product/${id}/upvote`
  );
  return response.data;
};
export interface DiscountProductParams {
  pageNumber?: number;
  pageSize?: number;
  minDiscount?: number;
  maxDiscount?: number;
}

export interface SortOptions {
  sortBy?: "discountPercentage" | "price" | "ourPrice" | "name";
  sortOrder?: "asc" | "desc";
}

export interface FilterParams {
  pageNumber?: number;
  pageSize?: number;
  search?: string;
  sortBy?: string;
  sortOrder?: string;
  minPrice?: number;
  maxPrice?: number;
  seriesId?: string | null;
  color?: string | string[];
  minDiscount?: number;
  maxDiscount?: number;
}

export interface FilterOptions {
  colors: Array<{ value: string; label: string; count: number }>;
  series: Array<{ value: string; label: string; count: number }>;
  priceRange: {
    minPrice: number;
    maxPrice: number;
    minDiscount: number;
    maxDiscount: number;
  };
}

export interface DiscountedProductsResponse {
  success: boolean;
  data: any[];
  pagination: {
    total: number;
    totalPages: number;
    currentPage: number;
    pageSize: number;
    hasNextPage: boolean;
    hasPreviousPage: boolean;
  };
  filters: {
    applied: any;
    available: FilterOptions;
  };
}

export const getDiscountedProducts = async (
  params?: FilterParams
): Promise<DiscountedProductsResponse> => {
  try {
    const response = await axiosInstance.get(
      `/api/v1/product/discounted/offer`,
      { params }
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching discounted products:", error);
    throw error;
  }
};
export const incrementProductViewCount = async (productId: any) => {
  try {
    const response = await axiosInstance.post(
      `/api/v1/product/${productId}/count`
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching discounted products:", error);
    throw error;
  }
};

export const getWishlistProducts = async () => {
  try {
    const response = await axiosInstance.get(
      `/api/v1/product/user/like/wishlist`
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching discounted products:", error);
    throw error;
  }
};
